import { useToastContext } from '../contexts/ToastContext';

export const useToast = () => {
  const { addToast } = useToastContext();

  const success = (message: string, description?: string, duration?: number) => {
    addToast({
      type: 'success',
      message,
      description,
      duration,
    });
  };

  const error = (message: string, description?: string, duration?: number) => {
    addToast({
      type: 'error',
      message,
      description,
      duration,
    });
  };

  const info = (message: string, description?: string, duration?: number) => {
    addToast({
      type: 'info',
      message,
      description,
      duration,
    });
  };

  const warning = (message: string, description?: string, duration?: number) => {
    addToast({
      type: 'warning',
      message,
      description,
      duration,
    });
  };

  return {
    success,
    error,
    info,
    warning,
  };
};

// Create a global toast instance that gets initialized by ToastProvider
let toastContext: ReturnType<typeof useToastContext> | null = null;

export const setToastContext = (context: ReturnType<typeof useToastContext>) => {
  toastContext = context;
};

// Global toast object for backward compatibility with react-hot-toast API
export const toast = {
  success: (message: string, description?: string, duration?: number) => {
    if (toastContext) {
      toastContext.addToast({
        type: 'success',
        message,
        description,
        duration: duration ?? 3000,
      });
    } else {
      console.warn('Toast context not initialized. Make sure ToastProvider is set up.');
    }
  },
  error: (message: string, description?: string, duration?: number) => {
    if (toastContext) {
      toastContext.addToast({
        type: 'error',
        message,
        description,
        duration: duration ?? 4000,
      });
    } else {
      console.warn('Toast context not initialized. Make sure ToastProvider is set up.');
    }
  },
  info: (message: string, description?: string, duration?: number) => {
    if (toastContext) {
      toastContext.addToast({
        type: 'info',
        message,
        description,
        duration: duration ?? 4000,
      });
    } else {
      console.warn('Toast context not initialized. Make sure ToastProvider is set up.');
    }
  },
  warning: (message: string, description?: string, duration?: number) => {
    if (toastContext) {
      toastContext.addToast({
        type: 'warning',
        message,
        description,
        duration: duration ?? 4000,
      });
    } else {
      console.warn('Toast context not initialized. Make sure ToastProvider is set up.');
    }
  },
};

